/**
 * Bottom-centre skill cluster widget (crest + HP / resource bars + skill rows + player cast bar
 * + XP hairline). Registered in widgets.ts; replaces the legacy action bar, player cast bar and
 * player frame.
 */
import type { HudWidgetDef } from '../widgets';
import { SkillCluster } from './skillCluster';

export { SkillCluster } from './skillCluster';
export { PlayerCastBar } from './castBar';
export { ProcOverlay, PROC_OVERLAYS } from './procOverlay';

export const skillClusterWidget: HudWidgetDef = {
  id: 'cluster',
  region: 'bottomCenter',
  replaces: ['actionBar', 'playerCast', 'playerFrame'],
  create: (host, ctx) => new SkillCluster(host, ctx.handlers, ctx.root),
};
